import { Switch } from 'antd';
import { SwitchChangeEventHandler, SwitchProps } from 'antd/es/switch';
import React from 'react';

// interface Iprops {
//   onChange: SwitchChangeEventHandler;
// }

const SwitchComponent = (props: SwitchProps) => {
  return <Switch size="small" {...props} />;
};

export default SwitchComponent;
